module.exports = __webpack_public_path__ + "static/media/plug_on.074db618.png";